import React, { useEffect, useState } from "react"

import { SlideShowContainer, Slide, PrevButton, NextButton, DotWrapper, Dot } from "./ImageCarousel.styles";


export default function PropertyPaneCarousel({ images }){

    const [slideIndex, setSlideIndex] = useState(1)

    const showSlides = (n) => {
        let i;
        const slides = document.getElementsByClassName('mySlides');
        const dots = document.getElementsByClassName('dot');
      
        if (n > slides.length) {
          setSlideIndex(1);
        }
      
        if (n < 1) {
          setSlideIndex(slides.length);
        }
      
        if (slides.length > 0) {
            for (i = 0; i < slides.length; i++) {
                slides[i].style.display = 'none';
            }
      
            if (slideIndex > 0 && slideIndex <= slides.length) {
                slides[slideIndex - 1].style.display = 'block';
            }
        }
      
        if (dots.length > 0) {
          for (i = 0; i < dots.length; i++) {
            dots[i].className = dots[i].className.replace(' active', '');
          }
      
          if (slideIndex > 0 && slideIndex <= dots.length) {
            dots[slideIndex - 1].className += ' active';
          }
        }
    };
    
    const plusSlides = (n) => {
        setSlideIndex(slideIndex + n);
    };
    
    const currentSlide = (n) => {
        setSlideIndex(n);
    };
    
    useEffect(() => {
        currentSlide(1)
    }, [])

    useEffect(() => {
        showSlides(slideIndex);
      }, [slideIndex]);

    let imagesUrls = []
    {images.map((image)=> {
        imagesUrls.push(image.src)
    })}
    
    return (
        <SlideShowContainer>
            <div>
                {imagesUrls.map((image, index) => (
                    <Slide key={index} className="mySlides fade">
                        <img src={image} alt={`Slide ${index}`} style={{ width: '100%' }} />
                        {/* <NumberText>{index + 1} / {numberOfImages}</NumberText> */}
                    </Slide>
                ))}
            </div>
            <PrevButton className="prev" onClick={() => plusSlides(-1)}>
                &#10094;
            </PrevButton>
            <NextButton className="next" onClick={() => plusSlides(1)}>
                &#10095;
            </NextButton>
            <DotWrapper>
                {imagesUrls.map((image, index) => (
                    <Dot key={image} className="dot" onClick={() => currentSlide(index + 1)}></Dot>
                ))}
            </DotWrapper>
            <br />
            
        </SlideShowContainer>
    )
}